<template lang="pug">
transition(name="fade")
  .material-window(v-if="isShowMaterial" @touchmove="onTouchMove")
    .background
    .material-content
      p.close(@click="hideMenu") close
      ul.materials
        li(@click="onSelect('red')").red
        li(@click="onSelect('green')").green
        li(@click="onSelect('blue')").blue
</template>

<script>
import { mapState, mapMutations } from 'Vuex'
import CONST from '~/js/modelviewer/constant'

export default {
  props:{},
  components: {},
  computed: {
     ...mapState('material', {isShowMaterial: 'isShowMaterial'}),
  },
  methods: {
    ...mapMutations('material', {hideMenu: 'hide'}),
   onTouchMove(e){
      e.preventDefault();
    },
    onSelect(name){
      this.hideMenu();
      if(name == CONST.MATERIAL.RED){
        this.$viewer.changeMaterial(CONST.MATERIAL.RED);
      }else if(name == CONST.MATERIAL.GREEN){
        this.$viewer.changeMaterial(CONST.MATERIAL.GREEN);
      }else if(name == CONST.MATERIAL.BLUE){
        this.$viewer.changeMaterial(CONST.MATERIAL.BLUE);
      }else{
        console.error(`wrong name: ${name}`);
        return;
      }
    }
  },
  created () {
    
  },
  mounted () {
    
  },
  data () {
    return {
    }
  },
}
</script>

<style lang="stylus" scoped>
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;
.material-window
  position fixed
  bottom 0
  left 0
  z-index 100
  width 100%
  height 200px
  .background
    width 100%
    height 100%
    background-color rgba(0, 0, 0, 0.5)
    position absolute
    top 0
    left 0
    z-index 0
  .material-content
    padding 20px 20px 0
    width 100%
    position relative
    z-index 1
    .close
      color white
      position absolute
      top 30px
      right 30px
      border white 1px solid
      cursor pointer
      width 60px
      height 30px
      text-align center
      line-height 30px
    
    ul
      display flex
    li
      height: 100px;
      width: 100px;
      border-radius: 50%;
      margin-left 30px
      cursor pointer
      
    li.red
      background-color: #ff0000;
    li.green
      background-color: #00ff00;
    li.blue
      background-color: #0000ff;
   

</style>
